module.exports = __webpack_public_path__ + "static/design-2-490db8676e4c592f10fe599063dff428.png";